/**
 * O painel de sugestoes.
 *
 * Cada linha traz a AFIRMACAO e a EVIDENCIA numerica que a gerou, mais "ver as
 * tarefas" e "dispensar". O motor nunca age sozinho: uma ferramenta que
 * redistribui card porque achou alguem sobrecarregado perde a confianca do
 * time na primeira vez que erra -- e vai errar, porque nao sabe o que foi
 * combinado fora dela.
 */
export const nav = {
    permissao: 'deck.sugestoes:ver',
    section: 'Gestao',
    title: 'Sugestoes',
    icon: 'lightbulb',
    route: '/sugestoes',
    sequence: 22,
};

export default [
    {
        path: '/sugestoes',
        name: 'sugestoes',
        component: () => import('./pages/SugestoesPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.sugestoes:ver' },
    },
];
